import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  HouseFill,
  InfoCircleFill,
  PeopleFill,
  CalendarEventFill,
  Newspaper,
  TelephoneFill,
  BoxArrowInRight,
  List,
  XLg,
  ChevronDown,
  BookFill
} from 'react-bootstrap-icons';
import logo from '../../Assets/img/logo_2.png';


const PublicHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isEventsDropdownOpen, setIsEventsDropdownOpen] = useState(false);
  const [isMembershipDropdownOpen, setIsMembershipDropdownOpen] = useState(false);
  const [isNewsUpdatesDropdownOpen, setIsNewsUpdatesDropdownOpen] = useState(false);
  const [isMobileAboutDropdownOpen, setIsMobileAboutDropdownOpen] = useState(false);
  const [isMobileEventsDropdownOpen, setIsMobileEventsDropdownOpen] = useState(false);
  const [isMobileMembershipDropdownOpen, setIsMobileMembershipDropdownOpen] = useState(false);
  const [isMobileNewsUpdatesDropdownOpen, setIsMobileNewsUpdatesDropdownOpen] = useState(false);
  const location = useLocation();

  const navigate = useNavigate(); // Initialize navigation

  const handleSignIn = () => {
    window.open("https://dashboard.apcci.in/", "_blank", "noopener,noreferrer");
    setIsMenuOpen(false);
  };


  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      if (window.innerWidth > 1024) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navItems = [
    { label: "Home", path: "/" },
    {
      label: "About Us",
      
      isDropdown: true,
      dropdownItems: [
        { label: "Who We Are", path: "/about/whoweare" },
        { label: "APCCI Objectives", path: "/about/objectives" },
        { label: "How We Empower You", path: "/about/how-we-empowers-you" },
        { label: "Governance Structure", path: "/about/governance-structure" },
        { label: "APCCI Leadership", path: "/our-board" },
        { label: "Functional Committees", path: "/our-committee" },
        // { label: "AICCC Organising Team", path: "/about/organising-team" },
      ],
    },
    {
      label: "Membership",
      
      isDropdown: true,
      dropdownItems: [
        { label: "Why Join APCCI", path: "/membership/why-join" },
        { label: "Membership Plans", path: "/membership/plans" },
        { label: "How to Join", path: "/membership/how-to-join" },
        { label: "Members' Directory", path: "/membership/member-directory" },
        { label: "Code of Conduct", 
          external: true,
          path: "https://storage.googleapis.com/msgsndr/dbCyS1PxNv5KL26lQx0V/media/67eeb7d8e416f17a28a458bf.pdf"
          
        },
        { label: "Join WhatsApp Community",
          external: true,
          path: "https://zfrmz.in/SIJmVXVlbuH8ENsTRVwx"
        }
      ],
    },
    {
      label: "Events",
      
      isDropdown: true,
      dropdownItems: [
        { label: "Annual Events", path: "/events/upcoming-events" },
        // { label: "Past Events", path: "/events/past-events" },
      ],
    },
    //{ label: "Resources", path: "/training-resources", icon: <BookFill size={18} /> },
    {  
      label: "News & Updates",
      isDropdown: true,
      dropdownItems: [
        { label: "Latest Updates", path: "/news-updates" },
        //{ label: "Press Releases", path: "https://apcci.in/press-releases", external: true },
      ],
    },
    { label: "Contact Us", path: "/contact-us"  },
  ];


  const styles = {
    header: {
      backgroundColor: 'white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      position: 'fixed',
      width: '100%',
      top: 0,
      left: 0,
      zIndex: 1000,
      padding: windowWidth <= 768 ? '5px 0' : '10px 0',
    },
    container: {

      padding: windowWidth <= 1200 ? '0px 20px' : '0px 40px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',

    },
    logo: {
      textDecoration: 'none',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '10px',
    },
    logoImage: {
      height: windowWidth <= 768 ? "50px" : "60px",
      width: "auto",
      marginLeft: windowWidth <= 768 ? '0' : '35px',
    },
    logoSubtext: {
      color: '#0d73b9',
      fontSize: windowWidth <= 768 ? '14px' : '17px',
      lineHeight: '1.2',
      marginTop: '2px',
      textAlign: 'left',
      
      paddingBottom: '3px',

    },
    nav: {
      display: windowWidth <= 1024 ? 'none' : 'flex',
      alignItems: 'center',
      gap: windowWidth <= 1200 ? '15px' : '24px',
    },
    navItem: {
      display: 'flex',
      alignItems: 'end',
      padding: windowWidth <= 1200 ? '6px 10px' : '8px 12px',
      textDecoration: 'none',
      color: windowWidth <= 1200 ? "#fff" : "rgb(0,0,0,0.7)",
      fontSize: windowWidth <= 1200 ? '14px' : '16px',
      fontWeight: '550',
      transition: 'all 0.3s ease',
      borderRadius: '8px',
      whiteSpace: 'nowrap',
      fontFamily: `'Poppins', sans-serif`,
      '&:hover': {
        background: '#0078BF',
      },
      marginTop:"2px",
      transition: 'all 0.3s ease',
      cursor: 'pointer'
    },    
    activeNavItem: {
      color: '#0078BF',
      border: '1px solid #fff',
      background: '#fff',
      fontWeight: '600',
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      marginRight: '8px',
    },
    buttons: {
      display: windowWidth <= 1024 ? 'none' : 'flex',
      alignItems: 'center',
      gap: '15px',
    },
    signInButton: {
      backgroundColor: '#E7F4FD',
      color: '#000',
      border: '1px solid #0078BF',
      borderRadius: '20px',
      padding: windowWidth <= 768 ? '8px 32px' : '16px 50px',
      fontSize: windowWidth <= 768 ? '16px' : '18px',
      fontWeight: '400',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      
    },
    mobileMenu: {
      display: windowWidth <= 1024 ? 'flex' : 'none',
      cursor: 'pointer',
      padding: windowWidth <= 1200 ? ' 4px' : ' 10px',
      background: "linear-gradient(180deg, rgb(0, 120, 191) 0%, rgb(36, 65, 131) 100%)",
      border: 'none',
      borderRadius: '8px',
      color: "#fff",
      alignItems: 'center',
    },
    mobileNav: {
      position: 'fixed',
      top: 0,
      right: isMenuOpen ? 0 : '-270px',
      height: '100%',
      width: '270px',
      background: "linear-gradient(180deg, rgb(0, 120, 191) 0%, rgb(36, 65, 131) 100%)",

      padding: '20px',
      boxShadow: '-2px 0 4px rgba(0,0,0,0.1)',
      transition: 'right 0.3s ease-in-out',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 1001,
    },
    mobileNavHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      padding: '10px 0',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
    closeButton: {
      background: 'none',
      border: 'none',
      color: '#fff',
      cursor: 'pointer',
      padding: '8px',
    },
    mobileNavItem: {
      padding: '8px 8px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      opacity: isMenuOpen ? 1 : 0,
      visibility: isMenuOpen ? 'visible' : 'hidden',
      transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out',
      zIndex: 1000,
    },
    dropdownMenu: {
      position: "absolute",
      top: "100%",
      left: 0,
      background: "#fff",
      boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
      borderRadius: "8px",
      overflow: "hidden",
      width: "200px",
      marginTop:"1px"
    },
    dropdownItem: {
      display: "block",
      padding: "8px 8px",
      color: "#0d73b9",
      textDecoration: "none",
     
    },
    mobileDropdownMenu: {
      display: isMobileAboutDropdownOpen ? 'block' : 'none',
      paddingLeft: '20px',
    },
  };

  return (
    <>
      <header style={styles.header}>
        <div style={styles.container}>
          <Link to="/" style={styles.logo}>
            <h1>
              <img src={logo} alt="APCCI Logo" style={styles.logoImage} />
            </h1>
            <p style={styles.logoSubtext} >
              <b>Association of Professional<br />
              Career Counsellors of India</b>
            </p>
          </Link>

          {/* Desktop Navigation */}
          <nav style={styles.nav}>
            {navItems.map((item, index) => (
              item.isDropdown ? (
                <div
                  key={index}
                  style={{ position: "relative" }}
                  onMouseEnter={() => {
                    if (item.label === "About Us") {
                      setIsAboutDropdownOpen(true);
                      setIsEventsDropdownOpen(false);
                      setIsMembershipDropdownOpen(false);
                      setIsNewsUpdatesDropdownOpen(false);
                    } else if (item.label === "Events") {
                      setIsEventsDropdownOpen(true);
                      setIsAboutDropdownOpen(false);
                      setIsMembershipDropdownOpen(false);
                      setIsNewsUpdatesDropdownOpen(false);
                    } else if (item.label === "Membership") {
                      setIsMembershipDropdownOpen(true);
                      setIsAboutDropdownOpen(false);
                      setIsEventsDropdownOpen(false);
                      setIsNewsUpdatesDropdownOpen(false);
                    } else if (item.label === "News & Updates") {
                      setIsNewsUpdatesDropdownOpen(true);
                      setIsAboutDropdownOpen(false);
                      setIsEventsDropdownOpen(false);
                      setIsMembershipDropdownOpen(false);
                    }
                  }}
                  onMouseLeave={() => {
                    if (item.label === "About Us") {
                      setIsAboutDropdownOpen(false);
                    } else if (item.label === "Events") {
                      setIsEventsDropdownOpen(false);
                    } else if (item.label === "Membership") {
                      setIsMembershipDropdownOpen(false);
                    } else if (item.label === "News & Updates") {
                      setIsNewsUpdatesDropdownOpen(false);
                  }}}
                >
                  <div
                    style={{
                      ...styles.navItem,
                      ...((item.label === "About Us" && location.pathname.startsWith("/about")) || 
                         (item.label === "Events" && location.pathname.startsWith("/event")) ||
                          (item.label === "Membership" && location.pathname.startsWith("/membership")) ||
                          (item.label === "News & Updates" && location.pathname.startsWith("/news-updates"))
                         ? styles.activeNavItem : {}),
                    }}
                  >
                    <span style={styles.iconContainer}>{item.icon}</span> {item.label}
                  </div>
                  {((item.label === "About Us" && isAboutDropdownOpen) || 
                    (item.label === "Events" && isEventsDropdownOpen) ||
                    (item.label === "Membership" && isMembershipDropdownOpen) ||
                    (item.label === "News & Updates" && isNewsUpdatesDropdownOpen)) && (
                    <div style={styles.dropdownMenu}>
                      {item.dropdownItems.map((subItem, subIndex) => {
                        const isExternal = subItem.external;
                        if (isExternal) {
                          return (
                            <a
                              key={subIndex}
                              href={subItem.path}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                ...styles.dropdownItem,
                              }}
                            >
                              {subItem.label}
                            </a>
                          );
                        }
                        return (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            style={{
                              ...styles.dropdownItem,
                              ...(location.pathname === subItem.path ? styles.activeNavItem : {}),
                            }}
                          >
                            {subItem.label}
                          </Link>
                        );
                      })}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={index}
                  to={item.path}
                  style={{
                    ...styles.navItem,
                    ...(location.pathname === item.path ? styles.activeNavItem : {}),
                  }}
                >
                  <span style={styles.iconContainer}>{item.icon}</span> {item.label}
                </Link>
              )
            ))}
          <div style={styles.buttons}>
            <button style={styles.signInButton} onClick={handleSignIn}>Member Login</button>
          </div>
          </nav>

          

          {/* Mobile Menu Button */}
          <button
            style={styles.mobileMenu}
            onClick={() => setIsMenuOpen(true)}
            aria-label="Open menu"
          >
            <List size={38} />
          </button>
        </div>

        {/* Mobile Navigation */}
        <div
          style={styles.overlay}
          onClick={() => setIsMenuOpen(false)}
        />
        <nav style={styles.mobileNav}>
          <div style={styles.mobileNavHeader}>
            <h2 style={{ color: '#fff', margin: 0, fontSize: '20px' }}>Menu</h2>
            <button
              style={styles.closeButton}
              onClick={() => setIsMenuOpen(false)}
              aria-label="Close menu"
            >
              <XLg size={20} />
            </button>
          </div>
          {navItems.map((item) => (
            item.isDropdown ? (
              <div key={item.label}>
                <div
                  style={{
                    ...styles.navItem,
                    ...styles.mobileNavItem,
                    ...((item.label === "About Us" && location.pathname.startsWith("/about")) || 
                       (item.label === "Events" && location.pathname.startsWith("/event")) ||
                       (item.label === "Membership" && location.pathname.startsWith("/membership")) ||
                       (item.label === "News & Updates" && location.pathname.startsWith("/news-updates"))
                       ? styles.activeNavItem : {}),
                  }}
                  onClick={() => {
                    if (item.label === "About Us") {
                      setIsMobileAboutDropdownOpen(!isMobileAboutDropdownOpen);
                      setIsMobileEventsDropdownOpen(false);
                      setIsMobileMembershipDropdownOpen(false);
                      setIsMobileNewsUpdatesDropdownOpen(false);
                    } else if (item.label === "Events") {
                      setIsMobileEventsDropdownOpen(!isMobileEventsDropdownOpen);
                      setIsMobileAboutDropdownOpen(false);
                      setIsMobileMembershipDropdownOpen(false);
                      setIsMobileNewsUpdatesDropdownOpen(false);
                    } else if (item.label === "Membership") {
                      setIsMobileMembershipDropdownOpen(!isMobileMembershipDropdownOpen);
                      setIsMobileAboutDropdownOpen(false);
                      setIsMobileEventsDropdownOpen(false);
                      setIsMobileNewsUpdatesDropdownOpen(false);
                    } else if (item.label === "News & Updates") {
                      setIsMobileNewsUpdatesDropdownOpen(!isMobileNewsUpdatesDropdownOpen);
                      setIsMobileAboutDropdownOpen(false);
                      setIsMobileEventsDropdownOpen(false);
                      setIsMobileMembershipDropdownOpen(false);
                  }}}
                >
                  <span style={styles.iconContainer}>{item.icon}</span>
                  {item.label}
                  <ChevronDown size={18} style={{ marginLeft: 'auto' }} />
                </div>
                <div style={{
                  ...styles.mobileDropdownMenu,
                  display: (item.label === "About Us" && isMobileAboutDropdownOpen) || 
                           (item.label === "Events" && isMobileEventsDropdownOpen) ||
                           (item.label === "Membership" && isMobileMembershipDropdownOpen) ||
                           (item.label === "News & Updates" && isMobileNewsUpdatesDropdownOpen)
                           ? 'block' : 'none'
                }}>
                  {item.dropdownItems.map((subItem) => (
                      subItem.external ? (
                        <a
                          key={subItem.label}
                          href={subItem.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            ...styles.navItem,
                            ...styles.mobileNavItem,
                          }}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {subItem.label}
                        </a>
                      ) : (
                        <Link
                          key={subItem.path}
                          to={subItem.path}
                          style={{
                            ...styles.navItem,
                            ...styles.mobileNavItem,
                            ...(location.pathname === subItem.path ? styles.activeNavItem : {}),
                          }}
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {subItem.label}
                        </Link>
                      )
                    ))}
                </div>
              </div>
            ) : (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  ...styles.navItem,
                  ...styles.mobileNavItem,
                  ...(location.pathname === item.path ? styles.activeNavItem : {}),
                }}
                onClick={() => setIsMenuOpen(false)}
              >
                <span style={styles.iconContainer}>{item.icon}</span>
                {item.label}
              </Link>
            )
          ))}
          <a
            href="https://dashboard.apcci.in/"
            target="_blank"
            rel="noopener"
            style={{
              ...styles.navItem,
              ...styles.mobileNavItem,
              marginTop: 'auto',
            }}
            onClick={() => setIsMenuOpen(false)}
          >
            <span style={styles.iconContainer}>
              <BoxArrowInRight size={18} />
            </span>
            Sign In
          </a>

        </nav>
      </header>
      <div style={{ height: windowWidth <= 768 ? '64px' : '70px' }} />
    </>
  );
};

export default PublicHeader;